exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".color-preview[data-v-6c4402f2]{height:33px}.color-picker-area.form-control[data-v-6c4402f2]{height:auto;padding:0 35px 0 0}.color-picker-modal-area>div[data-v-6c4402f2]{width:100%}", ""]);

